import { render } from "./ClientTagInput.vue?vue&type=template&id=7bedb7d2"
import script from "./ClientTagInput.vue?vue&type=script&lang=js"
export * from "./ClientTagInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__